'use strict';
const Router = require('autor');
Router.setRoutes(require('./routes.js'));
Router.setConfig(require('./router.config.js'));

const facebook = require('./facebook.js');

require('./menu.jsx');
require('./title-card.js').init();
require('./screen.js').init();


Router.navigateWillStart(function() {
  document.querySelector('body').classList.add('loading');
  // document.getElementById('overlay-title').innerHTML = 'Loading';
});

Router.routeDidBootstrap(function() {
  // Create new facebook share links
  facebook.createShareLinks();

  document.querySelector('body').classList.remove('loading');
});


module.exports = {
  google: require('./google-plus.js')
}



// WEBPACK FOOTER //
// ./src/js/index.js